import { parse as papaParse, ParseResult } from 'papaparse';
import { KostDataImportDatasetInputProcessorProgressEvent } from '@bindoc-projects/kost-data-import-domain-lib';
import {
  KOST_FILE_NAMES,
  KOST_FILES_REQUIRED,
  KostFileNames,
} from './de-kost-file.const';

export class P21FileParser {
  public static parse(
    files: {
      [fileType in KostFileNames]: string;
    },
    progressCallback: (
      event: KostDataImportDatasetInputProcessorProgressEvent,
    ) => void,
  ): {
    result?: { [fileType in KostFileNames]: string[][] };
    errors?: string[];
  } {
    progressCallback({ step: 'FILE_PARSING', current: 0, max: 1 });
    const data: {
      result?: { [fileType in KostFileNames]: string[][] };
      errors?: string[];
    } = {
      result: {
        ENTGELTE: null,
        FAB: null,
        FALL: null,
        ICD: null,
        OPS: null,
        KOSTEN: null,
      },
      errors: [],
    };

    KOST_FILE_NAMES.forEach((fileType) => {
      if (!files[fileType] && KOST_FILES_REQUIRED[fileType]) {
        if (!data.errors) {
          data.errors = [];
        }

        data.errors = data.errors.concat(
          `Keine Daten für ${fileType} gefunden.`,
        );
      } else if (files[fileType]) {
        const parserResult = papaParse(files[fileType], {
          skipEmptyLines: 'greedy',
        }) as unknown as ParseResult<string[]>;

        data.result[fileType] = parserResult.data;
      }
    });

    progressCallback({ step: 'FILE_PARSING', current: 1, max: 1 });

    return data;
  }
}
